import React from 'react';
import formatTime from 'mn-utils/formatTime';
import upperFirst from 'mn-utils/upperFirst';
import viewport$ from 'mn-utils/browser/emitters/viewport';

import toEllipsisMiddle from '../../../../utils/toEllipsisMiddle';

import Tooltip from '../../../dumb/Tooltip/B';
import Col from '../../../dumb/Col/D';
import MenuForItem from '../../../dumb/Menu/ForItem';
import {
  apiV2InvoicePdfDownload,
  apiV2InvoicePdfGenerate,
  apiV2InvoiceStatusUpdate
} from "../../../../api/admin/invoices";
import Caption from "../../../dumb/Caption/C";
import UpdateA from "../../../dumb/Button/UpdateA";
import ReportDownload from "../../../dumb/ReportDownload/B";
import {getDateRange} from "../../../dumb/IntervalFilter";
import formatNumCurrency from "../../../../utils/formatNumCurrency";
import {openPopupInfo} from "../../../../emitters/popup";

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  state: {
    viewport: viewport$.throttle(100),
  },
  rowHeight: 60,
  request: require('../../../../api/admin/invoices').apiV2InvoicesList,
  wrapper(render, setState, self) {
    function Item(props) {
      const {data} = props;
      const isPending = data.state === 'pending';
      const merchant = data.merchant || {};
      const volume = data.txs_amount || 0;
      const fileId = data.file_id || false;

      const generatePDF = (should_notify) => (
        apiV2InvoicePdfGenerate({
          invoice_id: data.id,
          should_notify
        }).then(() => {
          openPopupInfo(['Success', `PDF file was successfully generated. ${should_notify ? 'We\'ve already send it to your email.' : ''}`]);
        }).catch((err) => {
          openPopupInfo(['Error', err.message]);
        }).finally(() => {
          self.update()
        })
      );

      const pdfActions = !!fileId
          ? [{
            name: `Download PDF`,
            onClick() {
              window.open('/f2c/v1/console/file/' + fileId, '_blank').focus();
            }
          }] : [
            {
              name: `Generate PDF`,
              onClick() {
                return generatePDF(false)
              }
            },
            {
              name: `Generate & send PDF`,
              onClick() {
                return generatePDF(true);
              }
            }
          ];

      return (
        <div
          className={`w layoutRow fhaS fvaC h60 bxzBorderBox rlv lh fw7 f12 c2 tl lts0em
                    (wmin130|w1/5|pt19|pr10|pb23|pl19)>1 bgF bb1 bsbS bcbE8E8E8`}
        >
          <div>
            <Tooltip className="fhaS" title={data.number}>
              {data.number}
            </Tooltip>
          </div>
          <div>
            <Tooltip className="fhaS" title={data.id}>
              {data.id}
            </Tooltip>
          </div>
          <div>
            <Tooltip className="fhaS" title={merchant.name}>
              {merchant.name}
            </Tooltip>
          </div>
          <div>
            <Tooltip className="fhaS" title={data.amount}>
              {formatNumCurrency(data.amount)} {data.currency_code}
            </Tooltip>
          </div>
          <div>
            <Tooltip className="fhaS" title={volume}>
              {formatNumCurrency(volume)} {data.currency_code}
            </Tooltip>
          </div>
          <div className="f10">
            {data.created_at && formatTime(data.created_at, '{mmm}, {dd} {yyyy}')}
          </div>
          <div>
            {upperFirst(data.state)}
            <MenuForItem items={[
              ...pdfActions,
              {
                name: `Mark as ${isPending ? 'PAID' : 'PENDING'}`,
                onClick() {
                  apiV2InvoiceStatusUpdate({
                    id: data.id,
                    state: isPending ? 'paid' : 'pending',
                    remarks: ''
                  }).finally(() => {
                    self.update()
                  })
                },
              },
            ]}/>
          </div>
        </div>
      );
    }

    return (state, props) => {
      const noData = !state.data || !state.data.count;

      return (
        <>
          <div className="layoutRow jcSB aiC">
            <Caption>Invoices</Caption>
            <div className="layoutRow">
              <UpdateA
                className="pl10"
                name="Update table"
                onClick={self.update}
              />
              <ReportDownload
                className="pl10"
                prefix="admin-transactions"
                urlPrefix="/f2c/v1/admin/payments/"
                disabled={noData}
              />
            </div>
          </div>
          <div className="h360 mt20 rlv">
            <div className="abs sh sb10 st0 ov">
              <div className="abs s ov ovxA">
                <div className="wmin940 rlv h">
                  <div className="layoutRow fhaC fvaC r9 ov w1/5>1">
                    <Col>Invoice Number</Col>
                    <Col>ID</Col>
                    <Col>Retailer</Col>
                    <Col>Pending Invoice</Col>
                    <Col>TRX Volume</Col>
                    <Col>Invoice Created</Col>
                    <Col>Status</Col>
                  </div>
                  <div className="abs sh st45 sb ovH c0>.CircularProgress">
                    {render(Item)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    };
  },
});
